import { NgModule } from '@angular/core';
import { CartNavigatorService } from '~shared/modules/cart-navigator/cart-navigator.service';
import { CartLinkDirective } from '~shared/modules/cart-navigator/cart-link.directive';

@NgModule({
  declarations: [
    CartLinkDirective,
  ],
  exports: [
    CartLinkDirective
  ],
  providers: [
    CartNavigatorService
  ],
})
export class CartNavigatorModule {}
